import React from 'react'
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom'
import Form from './Personaldetails';
import { Link } from 'react-router-dom'


export default function applicationform() {
  return (
    <div> <h1>applicationform</h1>
    </div>
  )
}
